import { useRouter } from "next/router";
import { useMobileHeader } from "hocs/MobileHeaderContext";
import usePrefetchRoutes from "hooks/usePrefetchRoutes";
import { HomeIcon, MagnifyingGlassIcon, Bars3Icon } from "@heroicons/react/24/outline";
import { HomeIcon as HomeIconSolid, MagnifyingGlassIcon as MagnifyingGlassIconSolid } from "@heroicons/react/24/solid";

const TAB_VALUATIONS = "valuations";
const TAB_SEARCH = "search";
const TAB_MENU = "menu";

const MENU_PATHS = ["/menu", "/bank", "/organisation", "/company", "/reports", "/admin", "/profile", "/panel_of_valuers"];

function getActiveTab(pathname) {
  if (pathname === "/search") return TAB_SEARCH;
  if (MENU_PATHS.some((p) => pathname.startsWith(p))) return TAB_MENU;
  return TAB_VALUATIONS;
}

const TAB_URLS = {
  [TAB_VALUATIONS]: "/valuation/list",
  [TAB_SEARCH]: "/search",
  [TAB_MENU]: "/menu",
};
const TAB_ROUTES = Object.values(TAB_URLS);

const MobileBottomNav = () => {
  const router = useRouter();
  const { mobileBack } = useMobileHeader();

  // These three are the whole of mobile's primary navigation and they are all
  // light pages, so warm them up front — router.push does not prefetch the way
  // next/link does, and without this every tab tap waits on a chunk download.
  usePrefetchRoutes(TAB_ROUTES, !mobileBack);

  if (mobileBack) return null;

  const activeTab = getActiveTab(router.pathname);

  const urls = TAB_URLS;

  const handleTabClick = (key) => {
    const url = urls[key];
    if (url && router.pathname !== url) router.push(url);
  };

  const tabs = [
    { key: TAB_VALUATIONS, label: "Valuations", icon: HomeIcon, iconActive: HomeIconSolid },
    { key: TAB_SEARCH, label: "Search", icon: MagnifyingGlassIcon, iconActive: MagnifyingGlassIconSolid },
    { key: TAB_MENU, label: "Menu", icon: Bars3Icon, iconActive: Bars3Icon },
  ];

  return (
    <nav
      className="mobile-bottom-nav lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-center justify-center h-full gap-1 px-2">
        {tabs.map(({ key, label, icon: Icon, iconActive: IconActive }) => {
          const isActive = activeTab === key;
          const RenderIcon = isActive ? IconActive : Icon;
          return (
            <button
              key={key}
              onClick={() => handleTabClick(key)}
              className={`mobile-bottom-nav-tab ${isActive ? "mobile-bottom-nav-tab--active" : ""}`}
            >
              <RenderIcon className={`w-5 h-5 ${isActive ? "text-primary" : "text-muted-foreground"}`} />
              <span className={`text-[10px] leading-tight ${isActive ? "font-semibold text-primary" : "font-medium text-muted-foreground"}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
